export enum TimelineItemDurationContainerType {
  Default = 'Default',
  Blue = 'Blue',
  Purple = 'Purple',
  Green = 'Green',
}

export interface DurationNotificationProps {
  className?: string;
  type: TimelineItemDurationContainerType;
  duration: string;
}
